import LightboxHelper from '../../00_utilities/helpers/LightboxHelper';

class Lightbox {
    constructor(elem) {
        this.elem = elem;
        this.lightboxHelper = new LightboxHelper();
    }

    init() {
        let lightbox = {};
        if (this.elem) {
            lightbox = this.lightboxHelper.initLightbox();
            this.lightboxHelper.initLightboxEventHandler(this.elem, lightbox);
        }
    }
}

export default Lightbox;
